@for (child of item.content; track trackByName($index, child)) {
    <ng-container *vnPageMatrix="child" />
}
